import React from 'react'
import { ArrowRight, CalendarDays } from 'lucide-react'
import Reveal from '../components/Reveal'

const MOCK_COLORS = ['#c8d8e4','#b8ccd8','#d4e0e8','#bcccd8','#c0d0dc','#b4c8d4','#ccdae4','#b0c4d0','#c4d4e0']

export default function PostCard({ post, index }) {
  const hasThumb = !!post.thumb
  return (
    <Reveal variant="fade-up" delay={0.05 * (index % 3)} threshold={0.08}>
      <a href={post.link} className="arc-card">
        <div
          className="arc-card__thumb"
          style={{ background: hasThumb ? undefined : MOCK_COLORS[index % MOCK_COLORS.length] }}
        >
          {hasThumb
            ? <img src={post.thumb} alt={post.title} loading="lazy" />
            : (
              <div className="arc-card__thumb-mock">
                <svg viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="arc-card__thumb-svg">
                  <rect x="14" y="10" width="52" height="38" rx="2" stroke="currentColor" strokeWidth="1.2"/>
                  <circle cx="27" cy="23" r="5" stroke="currentColor" strokeWidth="1.2"/>
                  <path d="M14 38 L28 26 L38 34 L50 22 L66 38" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
                </svg>
              </div>
            )
          }
        </div>
        <div className="arc-card__body">
          <h3 className="arc-card__title" dangerouslySetInnerHTML={{ __html: post.title }} />
          <div className="arc-card__meta">
            <CalendarDays size={11} strokeWidth={1.5} />
            {post.date}
          </div>
          <p className="arc-card__excerpt">{post.excerpt}</p>
          <span className="arc-card__cta">
            Read more <ArrowRight size={12} strokeWidth={1.5} />
          </span>
        </div>
      </a>
    </Reveal>
  )
}
